const handleDeleteQuestionModalEquipService = {
  confirm: 'Deseja realmente deletar a pergunta',
  title: 'DELETAR PERGUNTA CHECKLIST'
};

export default handleDeleteQuestionModalEquipService;
